import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { List } from "immutable";
import * as React from "react";
import { errorText, noResultsText } from "../../../../custom_api/api";
import { BlockRenderer } from "../../../components/block_renderer";
import { Jumbo } from "../../../components/jumbo";
import { Link } from "../../../components/library/link";
import { Loader } from "../../../components/loader";
import { RoomFilter, capacityOptions } from "../../../components/room_filter";
import { SearchBarWrapper } from "../../../components/search_bar";
import { TeaserHasLinkContent } from '../../../components/teaser';
import { getDrupalRooms } from "./location_overview_page.utils";
export class LocationOverviewPage extends React.Component {
    async componentDidMount() {
        document.title = this.props.pageTitle;
        this.setState({
            drupalOvaticLocations: await getDrupalRooms()
        });
    }
    renderLocationOverview(drupalOvaticLocations) {
        if (drupalOvaticLocations == "loading") return /*#__PURE__*/ _jsx(Loader, {});
        if (drupalOvaticLocations == "error") return null;
        if (drupalOvaticLocations.size == 0) {
            return /*#__PURE__*/ _jsx("div", {
                className: "block block--activity-cluster container--lg align--center",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "container--m align--center text--styled",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "weight--bold container--s",
                        children: noResultsText
                    })
                })
            });
        }
        let eventTypes = drupalOvaticLocations.flatMap((l)=>List(l.ovaticLocation.eventTypes)).sortBy((t)=>t.toLocaleLowerCase().replace(/[^a-z0-9]/g, '')).toOrderedSet();
        const selectedCap = capacityOptions.get(this.state.filter.selectedCapacityOptionLabel);
        const minCap = selectedCap ? selectedCap.min : null;
        const maxCap = selectedCap ? selectedCap.max : null;
        const selectedType = this.state.filter.selectedEventType;
        let filtered = drupalOvaticLocations.filter((val)=>!selectedCap ? true : minCap <= val.ovaticLocation.capacity && val.ovaticLocation.capacity <= maxCap).filter((val)=>!selectedType ? true : val.ovaticLocation.eventTypes.findIndex((e)=>e == selectedType) != -1);
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(SearchBarWrapper, {
                    children: /*#__PURE__*/ _jsx(RoomFilter, {
                        enabled: true,
                        eventTypes: eventTypes,
                        selectCapacity: (selected)=>this.setState((prev)=>({
                                    filter: {
                                        ...prev.filter,
                                        selectedCapacityOptionLabel: selected
                                    }
                                })),
                        selectEventType: (selected)=>this.setState((prev)=>({
                                    filter: {
                                        ...prev.filter,
                                        selectedEventType: selected
                                    }
                                })),
                        selectedCapacity: this.state.filter.selectedCapacityOptionLabel,
                        selectedEventType: selectedType
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "block block--activity-cluster container--lg align--center",
                    children: /*#__PURE__*/ _jsx("ul", {
                        className: "teasers row",
                        children: filtered.map((room)=>this.renderLocationItem(room))
                    })
                })
            ]
        });
    }
    renderLocationItem(room) {
        return /*#__PURE__*/ _jsx("li", {
            className: "teaser teaser--haslink teaser--image col-xs-12 col-sm-6 col-md-4",
            children: /*#__PURE__*/ _jsx(Link, {
                url: room.url,
                className: "teaser__link",
                children: /*#__PURE__*/ _jsx(TeaserHasLinkContent, {
                    headingLevel: "h3",
                    title: room.title,
                    imageUrl: room.imageUrl,
                    imageUrlFallback: room.imageUrlFallback,
                    imageUrlLarge: room.imageUrlLarge,
                    imageAlt: room.image_alt,
                    intro: room.description ? room.description : room.ovaticLocation.description,
                    capacity: room.ovaticLocation.capacity,
                    price: room.price,
                    footer: "Meer informatie"
                })
            })
        }, `teaser-room-${room.ovatic_id}`);
    }
    render() {
        if (this.state.drupalOvaticLocations == "error") {
            return /*#__PURE__*/ _jsx("div", {
                className: "zalenverhuur",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "block block--activity-cluster container--lg align--center",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "container--m align--center text--styled",
                        children: /*#__PURE__*/ _jsx("p", {
                            className: "weight--bold container--s",
                            children: errorText
                        })
                    })
                })
            });
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "zalenverhuur",
            children: [
                /*#__PURE__*/ _jsx(Jumbo, {
                    title: this.props.headerTitle,
                    contents: this.props.description,
                    imageUrlSmall: this.props.jumboSize == 'small' && this.props.phImageUrlSmall ? this.props.phImageUrlSmall : undefined,
                    imageUrl: this.props.phImageUrl,
                    imageUrlFallback: this.props.phImageUrlFallback,
                    imageUrlLarge: this.props.phImageUrlLarge,
                    imageAlt: this.props.imageAlt,
                    buttonUrl: this.props.buttonUrl,
                    buttonTitle: this.props.buttonTitle,
                    size: this.props.jumboSize
                }),
                /*#__PURE__*/ _jsx(BlockRenderer, {
                    blocks: this.props.blocks_upper
                }),
                this.renderLocationOverview(this.state.drupalOvaticLocations),
                /*#__PURE__*/ _jsx(BlockRenderer, {
                    blocks: this.props.blocks
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            drupalOvaticLocations: "loading",
            filter: {
                selectedCapacityOptionLabel: "",
                selectedEventType: ""
            }
        };
    }
}
{}